import {
  faDownload,
  faPause,
  faPlay,
  faTrash,
  faVolumeHigh,
  faVolumeXmark,
} from "@fortawesome/free-solid-svg-icons";

import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { Button, Table, Pagination } from "react-bootstrap";
import ReactPlayer from "react-player";
import { GetAllRecordingList } from "../../../features/admin/recording_list/Slice.js";
import { useDispatch, useSelector } from "react-redux";
import { GetTotalRecordingList } from "../../../features/admin/all_recording_list/Slice.js";
import { IMG_URL } from "../../../utils/common.js";

const All_Recording_List = () => {
  const dispatch = useDispatch();
  const playerRefs = useRef({});

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const handlePlayerPlay = (id) => {
    setPlayingId(id);
  };

  const handlePlayerPause = (id) => {
    setPlayingId((prev) => {
      if (prev === id) {
        return null;
      }

      return prev;
    });
  };

  const handleMute = (id) => {
    setMutedIds((prev) => ({
      ...prev,
      [id]: !Boolean(prev[id]),
    }));
  };
  const [rdelete, setRDelete] = useState(false);
  const [deleteRow, setDeleteRow] = useState(null);
  const [deleteType, setDeleteType] = useState(null);
  const handleDeleteClick = (row) => {
    setDeleteRow(row);
    setDeleteType("single");
    setRDelete(true);
  };

  const handleWhatsApp = (row) => {
    const url = getRecordingUrl(row?.recording);

    if (!url) return;

    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
      `Recording: ${url}`,
    )}`;

    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  };

  const AllRecordingList = useSelector(
    (state) => state.all_recording.total_recording_list,
  );

  const fetch = async (page = 1) => {
    await dispatch(
      GetTotalRecordingList({
        name: name,
        email: email,
        page: page,
        per_page: 10,
      }),
    );
  };

  const handleHostPageChange = (page) => {
    if (page < 1) return;

    fetch(page);
  };

  useEffect(() => {
    fetch();
  }, [name, email]);

  const playerRef = useRef(null);

  const [isPlaying, setIsPlaying] = useState(false);
  const [played, setPlayed] = useState(0);
  const [duration, setDuration] = useState(0);
  const [muted, setMuted] = useState(false);
  const [playingId, setPlayingId] = useState(null);
  const [mutedIds, setMutedIds] = useState({});
  const [playedIds, setPlayedIds] = useState({});
  const [durationIds, setDurationIds] = useState({});

  const getRecordingUrl = (recording) => {
    if (!recording) {
      return "";
    }

    return IMG_URL(recording);
  };

  const handlePlayPause = async (id) => {
    const audio = playerRefs.current[id];

    if (!audio) {
      console.error("Audio element not found:", id);
      return;
    }

    try {
      if (playingId !== null && playingId !== id) {
        const currentAudio = playerRefs.current[playingId];

        if (currentAudio) {
          currentAudio.pause();
        }
      }

      if (playingId === id) {
        audio.pause();
        setPlayingId(null);
        return;
      }

      // Undo the end-of-file seek used to resolve .webm duration.
      if (audio.dataset.fixingDuration === "true" || audio.ended) {
        audio.dataset.fixingDuration = "false";
        audio.currentTime = 0;
      }

      await audio.play();

      setPlayingId(id);
    } catch (error) {
      console.error("Audio play error:", error);
      console.error("Audio URL:", audio.src);
    }
  };

  const renderPagination = (data, handlePageChange) => {
    if (!data) return null;

    const currentPage = Number(data.current_page || 1);
    const perPage = Number(data.per_page || 10);
    const total = Number(data.total || 0);

    const lastPage = Math.ceil(total / perPage);

    if (lastPage <= 1) {
      return null;
    }

    return (
      <div className="d-flex justify-content-end mt-3">
        <Pagination>
          <Pagination.Prev
            disabled={currentPage === 1}
            onClick={() => handlePageChange(currentPage - 1)}
          />

          {Array.from({ length: lastPage }, (_, index) => {
            const page = index + 1;

            return (
              <Pagination.Item
                key={page}
                active={page === currentPage}
                onClick={() => handlePageChange(page)}
              >
                {page}
              </Pagination.Item>
            );
          })}

          <Pagination.Next
            disabled={currentPage === lastPage}
            onClick={() => handlePageChange(currentPage + 1)}
          />
        </Pagination>
      </div>
    );
  };

  const formatTime = (seconds) => {
    if (
      seconds === null ||
      seconds === undefined ||
      !Number.isFinite(Number(seconds))
    ) {
      return "00:00";
    }

    const totalSeconds = Math.max(0, Math.floor(Number(seconds)));

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const remainingSeconds = totalSeconds % 60;

    if (hours > 0) {
      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0",
      )}:${String(remainingSeconds).padStart(2, "0")}`;
    }

    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds,
    ).padStart(2, "0")}`;
  };

  const formatDate = (date) => {
    if (!date) return "-";

    const parsedDate = new Date(date);

    if (Number.isNaN(parsedDate.getTime())) {
      return date;
    }

    return parsedDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <section className="All_Recording_List common_section">
      <div className="sectin_top">
        <h2 className="section_name">All Recording List</h2>
      </div>

      <div className="table-responsive custom-table-wrapper mt-2">
        <Table borderless className="custom-table text-center align-middle m-0">
          <thead>
            <tr>
              <th>Sr No</th>
              <th>Meeting Id</th>
              <th>Date</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Recording</th>
              <th>Recording Player</th>
            </tr>
          </thead>

          <tbody>
            {AllRecordingList.data.length > 0 ? (
              AllRecordingList.data.map((row, index) => {
                const rowId = row?.id;

                const recordingUrl = getRecordingUrl(row?.recording);

                const isPlaying = playingId === rowId;

                const isMuted = Boolean(mutedIds[rowId]);

                const played = Number(playedIds[rowId] || 0);

                const duration = Number.isFinite(Number(durationIds[rowId]))
                  ? Number(durationIds[rowId])
                  : 0;

                const currentTime = played * duration;
                return (
                  <tr
                    key={row.id}
                    className={index % 2 === 0 ? "row-even" : "row-odd"}
                  >
                    <td className="fw-bold">{row.id}</td>
                    <td className="fw-bold">{row?.Meeting?.id}</td>
                    <td className="fw-bold">{formatDate(row.createdAt)}</td>
                    <td className="fw-bold">{formatTime(row.start_time)}</td>
                    <td className="fw-bold">{formatTime(row.end_time)}</td>
                    <td>
                      {recordingUrl ? (
                        <div className="recording_player_wrapper">
                          <div className="custom_recording_player">
                            <audio
                              ref={(audio) => {
                                if (audio) {
                                  playerRefs.current[rowId] = audio;
                                } else {
                                  delete playerRefs.current[rowId];
                                }
                              }}
                              src={recordingUrl}
                              muted={isMuted}
                              preload="metadata"
                              onPlay={() => {
                                handlePlayerPlay(rowId);
                              }}
                              onPause={() => {
                                handlePlayerPause(rowId);
                              }}
                              onEnded={() => {
                                setPlayingId((prev) =>
                                  prev === rowId ? null : prev,
                                );

                                setPlayedIds((prev) => ({
                                  ...prev,
                                  [rowId]: 0,
                                }));
                              }}
                              onTimeUpdate={(e) => {
                                const audio = e.currentTarget;

                                if (audio.dataset.fixingDuration === "true") {
                                  if (Number.isFinite(audio.duration)) {
                                    audio.dataset.fixingDuration = "false";
                                    audio.currentTime = 0;

                                    setDurationIds((prev) => ({
                                      ...prev,
                                      [rowId]: audio.duration,
                                    }));
                                  }
                                  return;
                                }

                                if (
                                  Number.isFinite(audio.duration) &&
                                  audio.duration > 0
                                ) {
                                  setPlayedIds((prev) => ({
                                    ...prev,
                                    [rowId]: audio.currentTime / audio.duration,
                                  }));
                                }
                              }}
                              onLoadedMetadata={(e) => {
                                const audio = e.currentTarget;

                                // MediaRecorder .webm files report Infinity until
                                // seeked to the end, which forces the real duration.
                                if (!Number.isFinite(audio.duration)) {
                                  audio.dataset.fixingDuration = "true";
                                  audio.currentTime = 1e101;
                                  return;
                                }

                                setDurationIds((prev) => ({
                                  ...prev,
                                  [rowId]: audio.duration || 0,
                                }));
                              }}
                              onDurationChange={(e) => {
                                const audio = e.currentTarget;

                                if (!Number.isFinite(audio.duration)) {
                                  return;
                                }

                                setDurationIds((prev) => ({
                                  ...prev,
                                  [rowId]: audio.duration || 0,
                                }));
                              }}
                              onError={(e) => {
                                console.error(
                                  "AUDIO ERROR:",
                                  e.currentTarget.error,
                                );
                                console.error("AUDIO URL:", recordingUrl);
                              }}
                              style={{
                                display: "none",
                              }}
                            />

                            <button
                              type="button"
                              className="custom_play_btn"
                              onClick={() => {
                                handlePlayPause(rowId);
                              }}
                            >
                              <FontAwesomeIcon
                                icon={isPlaying ? faPause : faPlay}
                              />
                            </button>

                            <div
                              className="custom_progress_wrapper"
                              onClick={(e) => {
                                if (!duration) {
                                  return;
                                }

                                const rect = e.currentTarget.getBoundingClientRect();

                                if (!rect.width) {
                                  return;
                                }

                                const clickPosition = e.clientX - rect.left;

                                const percentage = clickPosition / rect.width;

                                const safePercentage = Math.max(
                                  0,
                                  Math.min(1, percentage),
                                );

                                const audio = playerRefs.current[rowId];

                                if (audio && Number.isFinite(audio.duration)) {
                                  audio.currentTime =
                                    safePercentage * audio.duration;
                                }

                                setPlayedIds((prev) => ({
                                  ...prev,
                                  [rowId]: safePercentage,
                                }));
                              }}
                            >
                              <div
                                className="custom_progress"
                                style={{
                                  width: `${Math.min(
                                    100,
                                    Math.max(0, played * 100),
                                  )}%`,
                                }}
                              />
                            </div>

                            <span className="player_time">
                              {formatTime(currentTime)}
                            </span>

                            <span className="player_slash">/</span>

                            <span className="player_time">
                              {formatTime(duration)}
                            </span>

                            <button
                              type="button"
                              className="custom_volume_btn"
                              onClick={() => handleMute(rowId)}
                            >
                              <FontAwesomeIcon
                                icon={isMuted ? faVolumeXmark : faVolumeHigh}
                              />
                            </button>
                          </div>
                        </div>
                      ) : (
                        <span className="text-muted">No Recording</span>
                      )}
                    </td>

                    <td>
                      <div className="delete_btn_div justify-content-center">
                        <button className="delete_selected">
                          <FontAwesomeIcon
                            icon={faTrash}
                            className="icon-delete"
                          />
                        </button>

                        <button className="delete_all"> Open Player</button>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="8" className="text-center fw-bold">
                  No Data
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <div className="result_div">
        <p className="inner_text">
          Showing{" "}
          {AllRecordingList?.data?.length > 0
            ? (AllRecordingList.current_page - 1) * AllRecordingList.per_page +
              1
            : 0}{" "}
          to{" "}
          {(AllRecordingList?.current_page - 1) * AllRecordingList?.per_page +
            (AllRecordingList?.data?.length || 0)}{" "}
          of {AllRecordingList?.total || 0}
        </p>
        {renderPagination(AllRecordingList, handleHostPageChange)}
      </div>
    </section>
  );
};

export default All_Recording_List;
